import {
    ADULT_LINK_ATTRIBUTE,
    ADULT_PAGE_GATE_ATTRIBUTE,
    ADULT_VERIFICATION_INLINE_SCRIPT_MARKER,
} from "./constants";

const loadAdultVerificationScript = async (): Promise<string | null> => {
    const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    const scriptSrc = `${publicUrl}/adult-verification.js`;

    try {
        const response = await fetch(scriptSrc, { cache: "no-cache" });
        if (!response.ok) {
            console.error("Failed to load adult-verification.js:", response.status);
            return null;
        }
        return response.text();
    } catch (error) {
        console.error("Failed to load adult-verification.js:", error);
        return null;
    }
};

const htmlNeedsAdultVerification = (html: string): boolean =>
    html.includes(ADULT_LINK_ATTRIBUTE) ||
    html.includes(ADULT_PAGE_GATE_ATTRIBUTE) ||
    html.includes("adult-verification-modal");

export const appendAdultVerificationScript = async (html: string): Promise<string> => {
    if (!htmlNeedsAdultVerification(html)) {
        return html;
    }

    if (html.includes(ADULT_VERIFICATION_INLINE_SCRIPT_MARKER)) {
        return html;
    }

    const scriptContent = await loadAdultVerificationScript();
    if (!scriptContent) {
        return html;
    }

    return `${html}<script ${ADULT_VERIFICATION_INLINE_SCRIPT_MARKER}>${scriptContent}<\/script>`;
};
